import { withDependencies } from '@wix/thunderbolt-ioc'
import { IViewerManagerImplementor } from 'thunderbolt-viewer-manager-types'
import { BrowserWindow, BrowserWindowSymbol } from '@wix/thunderbolt-symbols'
import { GridMeasures, IResponsiveDetachApi } from './types'
import { ResponsiveDetachApiSymbol } from './symbols'
import { getFullId } from '@wix/thunderbolt-commons'

export const ViewerManagerResponsiveApi = withDependencies(
	[BrowserWindowSymbol, ResponsiveDetachApiSymbol],
	(
		browserWindow: NonNullable<BrowserWindow>,
		responsiveDetachApi: IResponsiveDetachApi
	): IViewerManagerImplementor<'responsive'> => {
		const getLayoutContainer = (containerId: string) => {
			const nonInflatedContainerId = getFullId(containerId) // include repeater case
			const containerClass = `.${nonInflatedContainerId}-container`

			return browserWindow.document.querySelectorAll(
				`#${containerId}${containerClass}, #${containerId} ${containerClass}`
			)[0]
		}

		const getOverflowWrapper = (containerId: string) => {
			const nonInflatedContainerId = getFullId(containerId) // include repeater case
			return browserWindow.document.querySelector(`#${containerId} .${nonInflatedContainerId}-overflow-wrapper`)
		}

		const getScrollHeight = (compId: string): number | null => {
			const contentWrapper = getOverflowWrapper(compId) || getLayoutContainer(compId)

			return contentWrapper ? contentWrapper.scrollHeight : null
		}

		const getClientHeight = (compId: string): number | null => {
			const contentWrapper = getOverflowWrapper(compId) || getLayoutContainer(compId)

			return contentWrapper ? contentWrapper.clientHeight : null
		}

		const getScrollWidth = (compId: string): number | null => {
			const contentWrapper = getOverflowWrapper(compId) || getLayoutContainer(compId)

			return contentWrapper ? contentWrapper.scrollWidth : null
		}

		const getClientWidth = (compId: string): number | null => {
			const contentWrapper = getOverflowWrapper(compId) || getLayoutContainer(compId)

			return contentWrapper ? contentWrapper.clientWidth : null
		}

		const getGridMeasures = (compId: string): GridMeasures | {} => {
			const node = getLayoutContainer(compId)
			if (!node) {
				return {}
			}
			const { gridTemplateRows, gridTemplateColumns, gridRowGap, gridColumnGap } = browserWindow.getComputedStyle(
				node
			)
			return {
				gridTemplateRows,
				gridTemplateColumns,
				gridRowGap,
				gridColumnGap,
			}
		}

		return {
			responsive: {
				getScrollHeight,
				getClientHeight,
				getScrollWidth,
				getClientWidth,
				getGridMeasures,
				...responsiveDetachApi,
			},
		}
	}
)
